import { post, get, handleClientError } from '../lib'
import { getToken } from '../APIServices'

export type JobQueueRunType = 'DISTILLER' | 'SERVER'

export type JobQueueRunStatus =
  | 'NEW'
  | 'STARTED'
  | 'FINISHED'
  | 'ERROR'
  | 'LATER'
  | 'CANCELED'
  | 'UNKNOWN'

export interface JobQueueDevice {
  id: number
  name: string | null
  deleteFlag: boolean | null
  licensed: boolean | null
}

export interface JobQueueResponse {
  id: number | string
  _href: string
  dateCreated: string
  runStatus: JobQueueRunStatus
  lastError: string | null
  finished: string | null
  processOwner: string | null
  version: string | null
  jobType: string
  priority: number
  lastProcess: string | null
  arguments: string | null
  device: JobQueueDevice | null
  started: string | null
  runType: JobQueueRunType
}

type PostJobQueueResponse = Pick<JobQueueResponse, 'arguments'>

type PostJobQueuePayload = {
  arguments: string
  device?: string
  jobType: string
  runType: JobQueueRunType
}

export const postManualUpload = async (
  argument: string,
  deviceId: string
): Promise<PostJobQueueResponse> => {
  try {
    const res = await post<PostJobQueuePayload, JobQueueResponse>({
      path: `/api/v1/jobQueue`,
      body: {
        arguments: argument,
        device: deviceId,
        jobType: 'MANUAL_UPLOAD',
        runType: 'SERVER'
      }
    })
    return { arguments: res.arguments }
  } catch (e: any) {
    throw handleClientError(e)
  }
}

export const postIpaManual = async (
  analyzerId: string
): Promise<PostJobQueueResponse> => {
  try {
    const res = await post<PostJobQueuePayload, JobQueueResponse>({
      path: `/api/v1/jobQueue`,
      body: {
        arguments: analyzerId,
        jobType: 'IPA_MANUAL',
        runType: 'DISTILLER'
      }
    })
    return { arguments: res.arguments }
  } catch (e: any) {
    throw handleClientError(e)
  }
}

export const getJobById = async (
  jobId: string
): Promise<JobQueueResponse | null> => {
  try {
    const res = await get<JobQueueResponse>({
      path: `/api/v1/jobQueue/${jobId}`
    })
    return res
  } catch (e: any) {
    handleClientError(e)
    return null
  }
}

export const getJobStatus = async (
  jobId: string
): Promise<JobQueueResponse | null> => {
  return getJobById(jobId)
}

export const getDevice = async (id: number) => {
  const token = getToken()
  const res = await fetch(`/api/v1/devices/${id}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token
    }
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }
  return res.json()
}
